import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { AppShell, Content } from '../components/ui/AppShell';
import { useLeagues } from '../hooks/useQueries';

/**
 * The `/play/:leagueId/picks` route is a legacy deep-link target.
 *
 * Both sports build on the League Hub's Compete tab now — football's card builder
 * and cycling's duel-calling flow live inline there. Preserve query params so
 * `?round=` / `?fixture=` / `?duel=` still open the right builder on arrival.
 */
export default function PicksRoute() {
  const { leagueId } = useParams<{ leagueId: string }>();
  const [params] = useSearchParams();
  const { data: leagues } = useLeagues();

  if (!leagues) {
    return (
      <AppShell>
        <Content>
          <div className="h-40" />
        </Content>
      </AppShell>
    );
  }

  const qs = params.toString();
  return <Navigate to={`/play/${leagueId}${qs ? `?${qs}` : ''}`} replace />;
}
